export default {
  background_image: 'Imagen de fondo',
};
